export default __webpack_public_path__ + "static/media/popup_pergaminhos_03.9e987628.mp3";